import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../Spinner/Spinner';
import * as S from './BaseButton.styles';

const BaseButton = ({
  className,
  htmlTag,
  text,
  onClick,
  children,
  isLoading,
  spinnerColor,
  disabled,
  ...other
}) => {
  const Tag = htmlTag;

  return (
    <S.BaseButton>
      <Tag
        disabled={disabled || isLoading}
        className={`baseButton ${className}`}
        onClick={onClick}
        {...other}
      >
        {isLoading && (
          <S.Spinner className="loadingSpinner">
            <Spinner size="1rem" activeColor={spinnerColor} opacity="1" />
          </S.Spinner>
        )}
        {text || children}
      </Tag>
    </S.BaseButton>
  );
};

BaseButton.defaultProps = {
  children: '',
  className: null,
  disabled: false,
  htmlTag: 'button',
  isLoading: false,
  onClick: () => {},
  spinnerColor: '#fff',
  text: ''
};

BaseButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  // eslint-disable-next-line react/boolean-prop-naming
  disabled: PropTypes.bool,
  htmlTag: PropTypes.string,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  spinnerColor: PropTypes.string,
  text: PropTypes.string
};

export default BaseButton;
